export default function functionsDirective() {
  return {
    template: require('./functions.html'),
    controller: 'FunctionsController',
    controllerAs: 'functionsVM',
    scope: {
      customerId: '<',
      department: '=', // TODO: remove department from dependencies and then remove here (not used by this directive)
      process: '=', // TODO: remove process from dependencies and then remove here (not used by this directive)
      functions: '=',
      isEdit: '<',
      dialogOrigin: '<',
      showTitle: '<',
      isIt: '='
    },
    bindToController: true,
    replace: true,
  };
}
